<script setup>
import "@/assets/css/theme.min.css";
import "vue3-tel-input/dist/vue3-tel-input.css";
</script>

<template>
    <div
        class="modal fade"
        :id="modalId"
        data-bs-backdrop="false"
        tabindex="-1"
        :aria-labelledby="modalId"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="">
                        <p
                            class="text-black text-sm fw-semibold text-center"
                            style="line-height: 2.5"
                        >
                            Lock
                        </p>
                    </div>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">
                    <div class="row" v-if="stage == 1">
                        <div class="col-lg-12 text-center">
                            <h6>Unlock by Subscribing</h6>
                            <p>
                                Enter your details to be notified about new
                                content on this Allmyonline.
                            </p>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-floating mb-1">
                                <input
                                    class="form-control"
                                    type="email"
                                    id="fl-text"
                                    placeholder="Email"
                                    v-model="form.email"
                                />
                                <label for="fl-text">Email</label>
                            </div>
                        </div>

                        <div class="col-lg-12 mt-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="'checkbox-subscribe-required' + linkId"
                                    name="subscribe"
                                    v-model="subscribeAgree"
                                    required
                                />
                                <label
                                    class="form-check-label"
                                    :for="
                                        'checkbox-subscribe-required' + linkId
                                    "
                                >
                                    I agree to Allmyonline Terms and Conditions
                                    and Privacy Notice. (Required)</label
                                >
                            </div>
                        </div>
                        <div class="col-lg-12 mt-2">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="'checkbox-subscribe-1' + linkId"
                                    name="subscribe"
                                />
                                <label
                                    class="form-check-label"
                                    :for="'checkbox-subscribe-1' + linkId"
                                >
                                    I agree to my contact details being shared
                                    with zacb, who may contact me.</label
                                >
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <button
                                class="btn btn-dark mt-2 rounded-5"
                                @click="confirmStageOne"
                                :style="{ opacity: opacity }"
                                :disabled="disabled"
                            >
                                <span
                                    class="spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                    :class="loading"
                                ></span>
                                Subscribe
                            </button>
                        </div>
                    </div>
                    <div class="row" v-if="stage == 2">
                        <div class="col-lg-12 text-center">
                            <h6>Unlock link with a code</h6>
                        </div>
                        <div class="col-lg-12 m-auto">
                            <v-otp-input
                                :v-model="form.code"
                                input-classes="otp-input"
                                separator="-"
                                :num-inputs="4"
                                :should-auto-focus="true"
                                input-type="letter-numeric"
                                :placeholder="['*', '*', '*', '*']"
                                @on-complete="confirmStageTow"
                            ></v-otp-input>
                        </div>
                    </div>
                    <div class="row m-auto" v-if="stage == 3">
                        <div class="col-lg-12 text-center">
                            <h6>Unlock link with your Date of Birth</h6>
                        </div>
                        <div class="col-lg-3 m-auto">
                            <div class="form-floating mb-3">
                                <input
                                    class="form-control text-center"
                                    type="text"
                                    max="2"
                                    :id="'fl-day' + linkId"
                                    placeholder="DD"
                                    v-model="form.day"
                                />
                                <label
                                    :for="'fl-day' + linkId"
                                    style="text-align: center"
                                    >DD</label
                                >
                            </div>
                        </div>
                        <div class="col-lg-3 m-auto">
                            <div class="form-floating mb-3">
                                <input
                                    class="form-control text-center"
                                    max="2"
                                    type="text"
                                    :id="'fl-mm' + linkId"
                                    placeholder="MM"
                                    v-model="form.month"
                                />
                                <label
                                    :for="'fl-mm' + linkId"
                                    style="text-align: center"
                                    >MM</label
                                >
                            </div>
                        </div>
                        <div class="col-lg-4 m-auto">
                            <div class="form-floating mb-3">
                                <input
                                    class="form-control text-center"
                                    max="4"
                                    type="text"
                                    :id="'fl-year' + linkId"
                                    placeholder="YYY"
                                    v-model="form.year"
                                />
                                <label
                                    :for="'fl-year' + linkId"
                                    style="text-align: center"
                                    >YYYY</label
                                >
                            </div>
                        </div>

                        <div class="col-lg-12">
                            <button
                                class="btn btn-dark mt-2 rounded-5 col-lg-12"
                                @click="confirmStageThree(linkId)"
                                :style="{ opacity: opacity }"
                                :disabled="disabled"
                            >
                                <span
                                    class="spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                    :class="loading"
                                ></span>
                                Continue
                            </button>
                        </div>
                    </div>
                    <div class="row" v-if="stage == 4">
                        <div class="col-lg-12 text-center">
                            <h6>Content Warning</h6>
                            <p>
                                This link may contain content that is not
                                appropriate for all audiences.
                            </p>
                        </div>
                        <div class="col-lg-12">
                            <button
                                class="btn btn-dark mt-2 rounded-5 col-lg-12"
                                @click="confirmStageFour"
                                :style="{ opacity: opacity }"
                                :disabled="disabled"
                            >
                                <span
                                    class="spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                    :class="loading"
                                ></span>
                                I understand
                            </button>
                        </div>
                    </div>
                    <div class="row mt-3" v-if="validation">
                        <div class="col-lg-12 text-center text-danger">
                            {{ validation }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.otp-input {
    width: 30%;
    width: 30%;
    height: 40px;
    padding: 5px;
    margin: auto !important;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
}
/* Background colour of an input field with value */
.otp-input.is-complete {
    background-color: #e4e4e4;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input::placeholder {
    font-size: 15px;
    text-align: center;
    font-weight: 600;
}
.height-100 {
    height: 100vh;
}
.card {
    width: auto;
    border: none;
    height: 300px;
    box-shadow: 0px 5px 20px 0px #d2dae3;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}
.card h6 {
    color: red;
    font-size: 20px;
}
.inputs input {
    width: 40px;
    height: 40px;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
}
.card-2 {
    background-color: #fff;
    padding: 10px;
    width: 350px;
    height: 100px;
    bottom: -50px;
    left: 20px;
    position: absolute;
    border-radius: 5px;
}
.card-2 .content {
    margin-top: 50px;
}
.card-2 .content a {
    color: red;
}
.form-control:focus {
    box-shadow: none;
    border: 2px solid red;
}
.validate {
    border-radius: 20px;
    height: 40px;
    background-color: red;
    border: 1px solid red;
    width: 140px;
}
</style>
<style>
.arrow {
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    margin-left: 10px;
    transform: rotate(45deg);
    transition: transform 0.3s ease;
}

.arrow-down {
    transform: rotate(-135deg);
}
</style>
<script>
import VOtpInput from "vue3-otp-input";
export default {
    components: {
        VOtpInput,
    },
    props: {
        dataString: String,
        modalId: {
            type: String,
            required: true,
        },
        linkId: {
            required: true,
        },
        icon: {
            type: String,
        },
        data: {
            type: Object,
            required: true,
        },
        stageProps: {
            required: true,
        },
        unlockActive: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            validation: null,
            disabled: false,
            loading: "",
            opacity: "1",
            stage: this.stageProps,
            form: {
                email: null,
                code: null,
                day: null,
                month: null,
                year: null,
                subscribeAgree: false,
            },
        };
    },
    computed: {
        numberRange() {
            // Create an array of numbers from 12 to 99
            return Array.from({ length: 88 }, (v, k) => k + 12);
        },
    },
    watch: {
        stageProps(newVal) {
            this.stage = newVal;
        },
    },

    methods: {
        async confirmStageOne() {
            this.loading = "spinner-border";
            if (this.form.email == null) {
                this.validation = "There are required fields.";
                this.loading = "";
                this.stage = 1;
                return false;
            }
            try {
                const response = await axios.get(
                    route("unlock.link.subscribe", {
                        email: this.form.email,
                        subscribeAgree: this.form.subscribeAgree,
                        id: this.linkId,
                    })
                );
                if (response.data.message === true) {
                    this.validation = null;
                    this.loading = "";
                    if (this.data.code_lock_status == 1) {
                        this.stage = 2;
                    } else if (this.data.date_birth_status == 1) {
                        this.stage = 3;
                    } else if (this.data.sensitive_content_lock_status == 1) {
                        this.stage = 4;
                    }
                } else if (response.data.message === false) {
                    this.stage = 1;
                    this.validation = "";
                    this.loading = "";
                }
            } catch (error) {
                console.error("There was an error!", error);
            }
        },

        async confirmStageTow(code) {
            try {
                const url =
                    typeof route === "function" && route().has("link.unlock")
                        ? route("link.unlock")
                        : "/link/unlock";
                const response = await axios.post(url, {
                    link_id: this.linkId,
                    step: 1,
                    input: code,
                });
                if (response.data && response.data.success === true) {
                    this.validation = null;

                    if (this.data.date_birth_status == 1) {
                        this.stage = 3;
                    } else if (this.data.sensitive_content_lock_status == 1) {
                        this.stage = 4;
                    }
                } else if (response.data.message === false) {
                    this.stage = 2;
                    this.validation = "The verification code is incorrect";
                }
            } catch (error) {
                console.error("There was an error!", error);
            }
        },
        async confirmStageThree() {
            this.loading = "spinner-border";
            if (
                this.form.day == null ||
                this.form.month == null ||
                this.form.year == null
            ) {
                this.validation = "Enter your date of birth.";
                this.loading = "";
                this.stage = 3;
            }
            try {
                const url =
                    typeof route === "function" && route().has("link.unlock")
                        ? route("link.unlock")
                        : "/link/unlock";
                const dob = `${this.form.year}-${this.form.month}-${this.form.day}`;
                const response = await axios.post(url, {
                    link_id: this.linkId,
                    step: 2,
                    input: dob,
                });

                if (response.data && response.data.success === true) {
                    this.loading = null;
                    this.validation = null;

                    if (this.data.sensitive_content_lock_status == 1) {
                        this.stage = 4;
                    }
                } else if (response.data && response.data.success === false) {
                    this.stage = 3;
                    this.validation =
                        "You can't access this content because you haven't met the minimum age requirement.";
                    this.loading = "";
                }
            } catch (error) {
                console.error("There was an error!", error);
            }
        },
        async confirmStageFour() {
            this.loading = "spinner-border";

            try {
                const url =
                    typeof route === "function" && route().has("link.unlock")
                        ? route("link.unlock")
                        : "/link/unlock";
                const response = await axios.post(url, {
                    link_id: this.linkId,
                    step: 3,
                    input: true,
                });

                if (response.data && response.data.success === true) {
                    this.loading = null;
                    this.validation = null;
                    this.unlockActiveStageFive();
                } else {
                    this.stage = 4;
                    this.loading = "";
                    this.validation = "There was an error!";
                }
            } catch (error) {
                console.error("There was an error!", error);
                this.validation = "There was an error!";
            }
        },
        async unlockActiveStageFive() {
            try {
                const response = await axios.get(
                    route("unlock.link.active", {
                        id: this.linkId,
                    })
                );

                if (response.data.message === true) {
                    this.unlockActive("active");
                    $j("#unlock-form-" + this.linkId).modal("hide");
                } else if (response.data.message === false) {
                    this.stage = 4;
                    this.loading = "";
                    this.validation = "There was an error!";
                }
            } catch (error) {
                this.validation = "There was an error!";
                console.error("There was an error!", error);
            }
        },
    },
};
</script>
